export const getOrderStatusLabel = (status?: string): string => {
  const statuses: Record<string, string> = {
    CREATED: "Creado",
    PENDING_APPROVAL: "Pendiente por aprobar",
    PAID: "Pagado",
    PROCESSING: "Procesando",
    SHIPPED: "Enviado",
    DELIVERED: "Entregado",
    CANCELLED: "Cancelado",
    PENDING_PROOF: "Pendiente de comprobante",
  };
  return status ? statuses[status] || status : "Desconocido";
};